(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom--product-faqs"] && !Shopify.designMode) return;
  try {
    const faqAnimations = new WeakMap();
  const reduceFaqMotion = matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || reduceFaqMotion.matches) return;

    const summary = event.target.closest('.product-faqs__question');
    const details = summary?.parentElement;

    if (!(details instanceof HTMLDetailsElement) || typeof details.animate !== 'function') return;

    event.preventDefault();
    faqAnimations.get(details)?.finish();

    const opening = !details.open;
    const startHeight = details.offsetHeight;
    let endHeight;

    if (opening) {
      details.open = true;
      endHeight = details.offsetHeight;
    } else {
      details.open = false;
      endHeight = details.offsetHeight;
      details.open = true;
    }

    details.style.overflow = 'hidden';
    const animation = details.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration: 200, easing: 'ease-out', fill: 'both' }
    );

    faqAnimations.set(details, animation);

    animation.addEventListener(
      'finish',
      () => {
        if (!opening) details.open = false;
        animation.cancel();
        details.style.removeProperty('overflow');
        faqAnimations.delete(details);
      },
      { once: true }
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom--specification-table"] && !Shopify.designMode) return;
  try {
    class SpecificationTable extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const root = this;
      const image = root.querySelector('[data-spec-image]');
      const visual = root.querySelector('.spec-table__visual');
      const fillRow = root.querySelector('[data-spec-fill-row]');
      const fillComponents = [...root.querySelectorAll('[data-spec-fill-component]')];
      const rows = [...root.querySelectorAll('details[data-image]')];
      const desktop = window.matchMedia('(min-width: 901px)');

      const syncScrollbar = () => {
        rows.forEach((row) => {
          const content = row.querySelector('.spec-table__content');
          const track = row.querySelector('.spec-table__scrollbar');
          const thumb = row.querySelector('.spec-table__scrollbar-thumb');
          const isScrollable = row.open && content && content.scrollHeight > content.clientHeight;
          row.toggleAttribute('data-scrollable', isScrollable);
          if (!isScrollable || !track || !thumb) return;

          const thumbHeight = Math.max(30, track.clientHeight * (content.clientHeight / content.scrollHeight));
          const maxThumbOffset = track.clientHeight - thumbHeight;
          const maxScroll = content.scrollHeight - content.clientHeight;
          thumb.style.height = `${thumbHeight}px`;
          thumb.style.transform = `translateY(${maxScroll ? (content.scrollTop / maxScroll) * maxThumbOffset : 0}px)`;
        });
      };

      const ensureRowIsOpen = () => {
        if (rows.some((row) => row.open && !row.hidden)) return;

        const firstVisibleRow = rows.find((row) => !row.hidden);
        if (firstVisibleRow) firstVisibleRow.open = true;
      };

      const showFill = (selectionValid, selectedFill = '') => {
        if (!fillRow) return;

        if (!selectionValid) {
          fillRow.hidden = false;
          fillComponents.forEach((component) => (component.hidden = false));
          ensureRowIsOpen();
          requestAnimationFrame(syncScrollbar);
          return;
        }

        const hasMatch = fillComponents.some((component) => component.dataset.specFillComponent === selectedFill);
        fillRow.hidden = !hasMatch;
        fillComponents.forEach((component) => {
          component.hidden = component.dataset.specFillComponent !== selectedFill;
        });
        ensureRowIsOpen();
        requestAnimationFrame(syncScrollbar);
      };

      rows.forEach((row) => {
        const content = row.querySelector('.spec-table__content');
        const track = row.querySelector('.spec-table__scrollbar');
        const thumb = row.querySelector('.spec-table__scrollbar-thumb');

        content?.addEventListener('scroll', syncScrollbar, { signal });

        track?.addEventListener('pointerdown', (event) => {
          if (event.target === thumb || !content) return;
          const trackRect = track.getBoundingClientRect();
          content.scrollTop = ((event.clientY - trackRect.top) / trackRect.height) *
            (content.scrollHeight - content.clientHeight);
        }, { signal });

        thumb?.addEventListener('pointerdown', (event) => {
          if (!content || !track) return;
          const startY = event.clientY;
          const startScroll = content.scrollTop;
          thumb.setPointerCapture(event.pointerId);

          const moveThumb = (moveEvent) => {
            const maxThumbOffset = track.clientHeight - thumb.offsetHeight;
            if (!maxThumbOffset) return;
            content.scrollTop = startScroll +
              ((moveEvent.clientY - startY) / maxThumbOffset) * (content.scrollHeight - content.clientHeight);
          };

          const stopDragging = () => {
            thumb.removeEventListener('pointermove', moveThumb);
            thumb.removeEventListener('pointerup', stopDragging);
            thumb.removeEventListener('pointercancel', stopDragging);
          };
          thumb.addEventListener('pointermove', moveThumb, { signal });
          thumb.addEventListener('pointerup', stopDragging, { signal });
          thumb.addEventListener('pointercancel', stopDragging, { signal });
        }, { signal });

        row.querySelector('summary')?.addEventListener('click', (event) => {
          if (row.open) event.preventDefault();
        }, { signal });

        row.addEventListener('toggle', () => {
          requestAnimationFrame(syncScrollbar);
          if (!row.open || !visual) return;
          visual.hidden = !row.dataset.image;
          if (!row.dataset.image) return;
          image.src = row.dataset.image;
          image.alt = row.dataset.imageAlt;
        }, { signal });
      });

      desktop.addEventListener('change', () => {
        ensureRowIsOpen();
        requestAnimationFrame(syncScrollbar);
      }, { signal });
      window.addEventListener('resize', syncScrollbar, { signal });
      ensureRowIsOpen();
      showFill(root.dataset.selectionValid === 'true', root.dataset.selectedFill);
      requestAnimationFrame(syncScrollbar);

      document.addEventListener('variant:validation', (event) => {
        if (event.target?.dataset?.productId !== root.dataset.specProductId) return;

        const valid = event.detail?.result?.valid ?? true;
        root.dataset.selectionValid = String(valid);
        if (!valid) showFill(false);
      }, { signal });

      document.addEventListener('variant:update', (event) => {
        if (event.target?.dataset?.productId !== root.dataset.specProductId) return;
        if (root.dataset.selectionValid !== 'true') return;

        const nextRoot = event.detail?.data?.html?.querySelector(
          `[data-spec-table][data-spec-product-id="${root.dataset.specProductId}"]`
        );
        const selectedFill = nextRoot?.dataset?.selectedFill ?? '';
        root.dataset.selectedFill = selectedFill;
        showFill(true, selectedFill);
      }, { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  }

  if (!customElements.get('specification-table')) {
    customElements.define('specification-table', SpecificationTable);
  }
  } catch(e) { console.error(e); }
})();

})();
